import { render, staticRenderFns } from "./gps.vue?vue&type=template&id=2be9dbb2&"
import script from "./gps.vue?vue&type=script&lang=js&"
export * from "./gps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports